<template>
  <div class="pagebox">
    <button @click="value=value+1" :disabled="max?value>=max:false"><svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8 0L15.7942 11.475L0.205771 11.475L8 0Z" fill="var(--color-pri)"/>
</svg>
</button>
    <input :style="width?{width}:{}" type="text" v-model.number="value" class="page" @focusin="focus" ref="count"/>
    <button @click="value=value-1" :disabled="value<=1"><svg width="16" height="11" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8 10.8L0.205773 0.675049L15.7942 0.675051L8 10.8Z" fill="var(--color-pri)"/>
</svg>
</button>
  </div>
</template>

<script>
export default {
  props: ['max', 'defaultValue', 'width'],
  data () {
    return {
      value: 1
    }
  },
  mounted () {
    this.value = this.defaultValue
  },
  watch: {
    defaultValue () {
      this.value = this.defaultValue
    },
    value () {
      if (this.defaultValue !== this.value) {
        this.$emit('input', this.value)
      }
    }
  },
  methods: {
    focus () {
      setTimeout(() => {
        this.$refs.count.focus()
        this.$refs.count.setSelectionRange(0, this.$refs.count.value.length)
      }, 50)
    }
  }
}
</script>

<style lang="scss" scoped>
button {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  padding: 0;
}
.page {
  width: 60px;
  height: 40px;
  border: 1.5px solid var(--color-checked);
  border-radius: 5px;
  font-weight: 500;
  font-size: 24px;
  line-height: 35px;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  color: #6D6D6D;
}
.pagebox {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
</style>
